import './App.css';
import boxing from '../src/assets/boxing.png';
import ClassPicture from '../src/assets/ClassPicture.png';
import FitnessRoom from '../src/assets/FitnessRoom.png';
import GirlAndManTraining from '../src/assets/GirlAndManTraining.png';
import GroupClassTraining from '../src/assets/GroupClassTraining.png';
import GroupTraining from '../src/assets/GroupTraining.png';
import GymImage from '../src/assets/GymImage.png';
import GymViewImage from '../src/assets/GymViewImage.png';
import ImageOfGymCamera from '../src/assets/ImageOfGymCamera.png';
import ImageOfTheGym from '../src/assets/ImageOfTheGym.png';
import JabAndBackground from '../src/assets/JabAndBackground.png';
import LegsUpExcercise from '../src/assets/LegsUpExcercise.png';
import LegsUpExcerciseLadyInPinkAndMan from '../src/assets/LegsUpExcerciseLadyInPinkAndMan.png';
import PushupExcercise from '../src/assets/PushupExcercise.png';
import PushupPostWorkoutCoolingDown from '../src/assets/PushupPostWorkoutCoolingDown.png';
import shotFromBehindPov from '../src/assets/shotFromBehindPov.png';
import ShotFromTheSideTrainingExperience from '../src/assets/ShotFromTheSideTrainingExperience.png';
import TrainingSession from '../src/assets/TrainingSession.png';
import WarmingUp from '../src/assets/WarmingUp.png';

function App() {
  return (
      <div className="App">
        {/* Hero Section with Background Image */}
        <header className="hero-section">
          <div className="hero-background" style={{
            backgroundImage: `url(${ImageOfTheGym})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}></div>
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Ontdek Jouw Kracht bij Aroepa Fit Kickboxing</h1>
            <p>Professionele kickbokslessen in een uitdagende én veilige omgeving</p>
            <button className="cta-button">GRATIS PROEFLES BOEKEN</button>
          </div>
        </header>

        {/* Benefits Section */}
        <section className="benefits-section">
          <h2>Waarom Kickboksen bij Aroepa Fit?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-image">
                <img src={LegsUpExcercise} alt="Full-body workout" />
              </div>
              <h3>🔥 Full-Body Workout</h3>
              <p>Verbeter conditie, kracht en flexibiliteit in één training</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-image">
                <img src={ShotFromTheSideTrainingExperience} alt="Professional guidance" />
              </div>
              <h3>🥊 Professionele Begeleiding</h3>
              <p>Ervaren trainers met aandacht voor techniek en veiligheid</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-image">
                <img src={GroupTraining} alt="Community feeling" />
              </div>
              <h3>👥 Gemeenschapsgevoel</h3>
              <p>Train in een motiverende omgeving met gelijkgestemden</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-image">
                <img src={JabAndBackground} alt="Confidence boost" />
              </div>
              <h3>💪 Zelfvertrouwen Boost</h3>
              <p>Ontwikkel mentale weerbaarheid en zelfverdedigingsvaardigheden</p>
            </div>
          </div>
        </section>

        {/* Gym Showcase */}
        <section className="gym-showcase">
          <div className="showcase-content">
            <div className="showcase-text">
              <h2>Onze Topmoderne Trainingsfaciliteiten</h2>
              <p>Train in onze volledig uitgeruste kickboksgym met:</p>
              <ul>
                <li>Professionele bokszakken</li>
                <li>Kracht- en conditieruimte</li>
                {/*<li>Ruime kleedkamers met douches</li>*/}
                <li>Veilige trainingsvloeren</li>
                <li>Goede ventilatie</li>
              </ul>
            </div>
            <div className="showcase-images">
              <img src={GymImage} alt="Gym overview" className="main-showcase" />
              <div className="secondary-images">
                <img src={FitnessRoom} alt="Fitness room" />
                <img src={ImageOfGymCamera} alt="Gym equipment" />
              </div>
            </div>
          </div>
        </section>

        {/* Training Programs */}
        <section className="programs-section">
          <h2>Onze Trainingsprogramma's</h2>
          <div className="program-cards">
            <div className="program-card">
              <div className="program-image">
                <img src={WarmingUp} alt="Beginner kickboxing" />
              </div>
              <h3>Beginners Kickboksen</h3>
              <ul>
                <li>Stapsgewijze techniektraining</li>
                <li>Focus op basisvaardigheden</li>
                <li>3 lessen per week</li>
                <li className="price">€65/maand</li>
              </ul>
              <button className="program-button">Meer informatie</button>
            </div>
            <div className="program-card popular">
              <span className="popular-tag">MEEST POPULAIR</span>
              <div className="program-image">
                <img src={TrainingSession} alt="Advanced training" />
              </div>
              <h3>Gevorderden Training</h3>
              <ul>
                <li>Intensieve techniek- en conditietraining</li>
                <li>Sparring sessies (optioneel)</li>
                <li>Onbeperkte lessen</li>
                <li className="price">€85/maand</li>
              </ul>
              <button className="program-button">Meer informatie</button>
            </div>
            <div className="program-card">
              <div className="program-image">
                <img src={GirlAndManTraining} alt="Private lessons" />
              </div>
              <h3>Privélessen</h3>
              <ul>
                <li>Persoonlijke 1-op-1 coaching</li>
                <li>Op maat gemaakt programma</li>
                <li>Flexibele planning</li>
                <li className="price">€75/1u30min</li>
                <li className="highlight">Extra lange sessie voor maximale vooruitgang!</li>
              </ul>
              <button className="program-button">Meer informatie</button>
            </div>
          </div>
        </section>

        {/* Training Gallery */}
        <section className="training-gallery">
          <h2>Bekijk Onze Trainingssessies in Actie</h2>
          <div className="gallery-grid">
            <img src={PushupExcercise} alt="Training session" />
            <img src={LegsUpExcercise} alt="Leg exercise" />
            <img src={LegsUpExcerciseLadyInPinkAndMan} alt="Partner exercise" />
            <img src={PushupPostWorkoutCoolingDown} alt="Cooling down" />
            <img src={GroupClassTraining} alt="Group class" />
            <img src={ShotFromTheSideTrainingExperience} alt="Technique training" />
          </div>
        </section>

        {/* Testimonials (without photos) */}
        <section className="testimonials">
          <h2>Wat Onze Leden Zeggen</h2>
          <div className="testimonial-cards">
            <div className="testimonial">
              <p>"Binnen 3 maanden 8kg afgevallen en mijn zelfvertrouwen is verdubbeld!"</p>
              <p className="author">- Thomas, 32</p>
            </div>
            <div className="testimonial">
              <p>"De trainers hebben geduld en weten precies hoe ze je moeten motiveren."</p>
              <p className="author">- Sanne, 28</p>
            </div>
            <div className="testimonial">
              <p>"De privélessen van 1u30 zijn elke euro waard - ik boek ze wekelijks!"</p>
              <p className="author">- Mike, 35</p>
            </div>
          </div>
        </section>

        {/* Class Schedule */}
        <section className="schedule-section">
          <div className="schedule-content">
            <div className="schedule-image">
              <img src={ClassPicture} alt="Class in session" />
            </div>
            <div className="schedule-text">
              <h2>Onze Lessenrooster</h2>
              <p>Train wanneer het jou uitkomt met onze flexibele planning:</p>
              <div className="schedule-grid">
                <div className="schedule-day">
                  <h3>Maandag</h3>
                  <p>18:00 - Beginners</p>
                  <p>19:30 - Gevorderden</p>
                  <p>20:45 - Sparring</p>
                </div>
                <div className="schedule-day">
                  <h3>Dinsdag</h3>
                  <p>17:30 - Kickboksen voor vrouwen</p>
                  <p>19:00 - Gevorderden</p>
                  <p>20:30 - Conditietraining</p>
                </div>
                <div className="schedule-day">
                  <h3>Woensdag</h3>
                  <p>18:30 - Techniektraining</p>
                  <p>20:00 - Gevorderden</p>
                </div>
                <div className="schedule-day">
                  <h3>Donderdag</h3>
                  <p>18:00 - Beginners</p>
                  <p>19:30 - Gevorderden</p>
                  <p>21:00 - Sparring</p>
                </div>
                <div className="schedule-day">
                  <h3>Vrijdag</h3>
                  <p>18:30 - Vrij trainen</p>
                    <p>20:00 - Techniek & Sparren</p>
                </div>
                {/*<div className="schedule-day">*/}
                {/*  <h3>Zaterdag</h3>*/}
                {/*  <p>10:00 - Gezinstraining</p>*/}
                {/*  <p>12:00 - Conditietraining</p>*/}
                {/*</div>*/}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section" style={{backgroundImage: `linear-gradient(rgba(211, 47, 47, 0.9), url(${boxing})`}}>
          <div className="cta-content">
            <h2>Klaar voor Verandering?</h2>
            <p>Boek vandaag nog je gratis proefles en ervaar het zelf!</p>
            <button className="cta-button">START NU MET KICKBOKSEN</button>
            <p className="small-text">Geen inschrijfkosten · Geen langlopende contracten</p>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="footer-content">
            <div className="contact-info">
              <h3>Aroepa Fit Kickboxing</h3>
              <p>Dijckerhoek 72, 's-Gravenzande</p>
              <p>📞 06 2396 6002</p>
              <p>✉️ info@aroepafit.nl</p>
            </div>
            <div className="footer-gallery">
              <img src={shotFromBehindPov} alt="Gym view" />
              <img src={GymViewImage} alt="Gym interior" />
              <img src={TrainingSession} alt="Group training" />
            </div>
            <div className="social-links">
              <a href="#">Instagram</a>
              <a href="#">Facebook</a>
              <a href="#">TikTok</a>
            </div>
          </div>
          <p className="copyright">© 2023 Aroepa Fit. Alle rechten voorbehouden.</p>
        </footer>
      </div>
  );
}

export default App;